<template>
  <div
    class="custom-tabs"
    :class="{
      'custom-tabs--title': Boolean(title),
      'custom-tabs--right-slot': mode === 'right-slot',
      'custom-tabs--sticky': sticky,
    }"
    :style="{
      backgroundColor: color,
    }"
  >
    <!-- 标签栏：包含返回箭头、标签项和右侧内容 -->
    <div class="tab-header">
      <!-- 返回箭头 -->
      <div class="back-arrow" @click="goBack" v-if="hasBack">
        <van-icon name="arrow-left" :size="20" class="arrow-icon" />
      </div>
      <div class="tab-items">
        <template v-if="title">
          <div class="tab-item active">{{ devSyncText(title) }}</div>
        </template>
        <template v-else>
          <!-- 标签项 -->
          <div
            v-for="tab in tabs"
            :key="tab.name"
            :class="['tab-item', { active: activeTab === tab.name }]"
            @click="handleTabClick(tab.name)"
          >
            {{ devSyncText(tab.title) }}
            <!-- 底部指示器 -->
            <template v-if="activeTab === tab.name && tabs.length > 1">
              <div v-if="lineStyle == 1" class="tab-indicator"></div>
              <img
                v-if="lineStyle == 2"
                class="tab-indicator-bent"
                :src="require('@/assets/icon/bent-line.png')"
              />
            </template>
          </div>
        </template>
      </div>
      <!-- 右侧插槽 -->
      <div v-if="mode === 'right-slot'" class="tab-right">
        <slot name="right"></slot>
      </div>
    </div>

    <!-- 内容区域 -->
    <!-- <div class="tab-content">
      <slot :activeTab="activeTab"></slot>
    </div> -->
  </div>
</template>

<script>
import mobileOrderI18n from "@/i18n/common/index";
export default {
  mixins: [mobileOrderI18n],
  name: "CustomTabs",
  props: {
    hasBack: {
      type: Boolean,
      default: true,
    },
    backUrl: {
      type: String,
      default: "",
    },
    // 当前激活的标签
    activeTab: {},
    // 标签列表
    tabs: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    // 是否显示返回箭头（默认为 true）
    showBack: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
    },
    // 兼容旧调用参数；导航高度统一由公共样式控制，不再使用 pb。
    pb: {
      type: String,
    },
    // right-slot 模式：标题居中，右侧区域由父组件通过插槽提供
    mode: {
      type: String,
      default: "default",
      validator: (value) => ["default", "right-slot"].includes(value),
    },
    sticky: {
      type: Boolean,
      default: false,
    },
    lineStyle: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    // 在 Vue 组件的 methods 中定义
    goBack() {
      // 页面存在内部层级时，可监听 back 事件自行处理；未监听时保持原逻辑。
      if (this.$listeners.back) {
        this.$emit("back");
        return;
      }
      // 1. 优先使用尝试返回上一页
      const hasPrevPage = window.history.length > 1;
      if (hasPrevPage) {
        // 有上一页且来源是本站，正常返回
        this.$router.go(-1);
      } else {
        // 2.无上一页或从外部直接进入，返回会脱离项目
        if (this.backUrl) {
          //有backUrl，返回backUrl
          this.$router.replace(this.backUrl);
        } else {
          //没有backUrl，重定向到首页
          this.$router.replace("/home");
        }
      }
    },
    // 处理标签点击事件
    handleTabClick(tabName) {
      if (this.activeTab !== tabName) {
        // 触发自定义事件通知父组件
        this.$emit("update:activeTab", tabName);
      }
    },
  },
};
</script>

<style scoped lang="less">
.custom-tabs {
  width: 100%;
  min-height: @mobile-nav-height;
  box-sizing: border-box;
  font-family: Source Han Sans;
  padding-top: @mobile-nav-vertical-padding;
  padding-top: calc(
    @mobile-nav-vertical-padding + constant(safe-area-inset-top)
  );
  padding-top: calc(@mobile-nav-vertical-padding + env(safe-area-inset-top));
  padding-bottom: @mobile-nav-vertical-padding;

  &--sticky {
    position: sticky;
    top: 0;
    z-index: var(--m-z-sticky, 100);
  }

  .tab-header {
    position: relative;
    display: grid;
    grid-template-columns: @mobile-nav-content-height minmax(0, 1fr) minmax(
        @mobile-nav-content-height,
        auto
      );
    align-items: center;
    width: 100%;
    min-height: @mobile-nav-content-height;
    height: auto;
  }

  .back-arrow {
    grid-column: 1;
    grid-row: 1;
    position: relative;
    z-index: 2;
    display: flex;
    width: @mobile-nav-content-height;
    height: @mobile-nav-content-height;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .arrow-icon {
      margin-left: 0;
      color: #3b3b3b;
      font-size: 20px;
    }
  }

  .tab-items {
    grid-column: 2;
    grid-row: 1;
    position: static;
    display: flex;
    width: auto;
    min-width: 0;
    align-items: center;
    justify-content: center;
    gap: clamp(8px, 4vw, 24px);

    .tab-item {
      position: relative;
      display: flex;
      min-width: 0;
      min-height: @mobile-nav-content-height;
      height: auto;
      padding: 8px 0;
      box-sizing: border-box;
      flex: 1;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #3b3b3b;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      text-align: center;
      white-space: normal;
      overflow-wrap: anywhere;

      &.active {
        color: #4286f5;
        font-size: 17px;
        font-weight: 600;
      }
    }

    .tab-indicator {
      position: absolute;
      bottom: 3px;
      width: 32px;
      height: 3px;
      border-radius: 3px;
      background: #4286f5;
      transition: transform 0.3s ease;
    }

    .tab-indicator-bent {
      position: absolute;
      bottom: 0;
      width: 26px;
      height: 6px;
      transition: transform 0.3s ease;
    }
  }

  .tab-right {
    grid-column: 3;
    grid-row: 1;
    position: relative;
    z-index: 2;
    display: flex;
    min-width: @mobile-nav-content-height;
    height: @mobile-nav-content-height;
    box-sizing: border-box;
    padding-right: 16px;
    margin-left: auto;
    align-items: center;
    justify-content: flex-end;
    text-align: right;
  }

  &--title {
    .tab-items .tab-item.active {
      color: #3b3b3b;
      font-weight: 700;
    }
  }

  &--right-slot {
    max-width: 630px;
    margin: 0 auto;
  }
}
</style>
